// ─────────────────────────────────────────────
//  utils/format.js
//  Shared number formatting utilities
//
//  NOTE RN: these helpers are framework-agnostic
//  and can be imported unchanged in React Native.
// ─────────────────────────────────────────────

function isWholeNumber(value) {
	return Math.abs(value - Math.round(value)) < 1e-9;
}

/**
 * Format a number with thousands separators.
 * Omits decimals when the value is a whole number.
 */
export function formatAmount(value, { forceInteger = false } = {}) {
	if (typeof value !== 'number' || isNaN(value)) return '—';

	if (forceInteger || isWholeNumber(value)) {
		return Math.round(value)
			.toFixed(0)
			.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
	}

	const trimmed = value.toFixed(2).replace(/\.?0+$/, '');
	const [intPart, decPart] = trimmed.split('.');
	const formattedInt = intPart.replace(/\B(?=(\d{3})+(?!\d))/g, ',');

	return decPart !== undefined ? `${formattedInt}.${decPart}` : formattedInt;
}

/**
 * Format a number as USD currency string.
 * e.g. 1234 → "$ 1,234", 1234.5 → "$ 1,234.5"
 */
export function formatCurrency(value, options) {
	const formatted = formatAmount(value, options);
	return formatted === '—' ? formatted : '$ ' + formatted;
}

/**
 * Format a percentage for display
 * e.g. 15 → "15%"
 */
export function formatPercent(value) {
	return `${Math.round(value)} %`;
}
